module.exports = __webpack_public_path__ + "static/media/banner6.cab04218.jpg";